import { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import confetti from 'canvas-confetti';
import { Gift } from 'lucide-react';

export const TierCelebration = ({ loyalty, onClose }) => {
  useEffect(() => {
    const fire = (particleRatio, opts) =>
      confetti({ origin: { y: 0.6 }, zIndex: 10000, particleCount: Math.floor(200 * particleRatio), ...opts });
    fire(0.25, { spread: 26, startVelocity: 55 });
    fire(0.2, { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
    fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    fire(0.1, { spread: 120, startVelocity: 45 });
    const timer = setTimeout(() => fire(0.3, { spread: 100, startVelocity: 40 }), 900);
    return () => clearTimeout(timer);
  }, []);

  const perkLabels = {
    drink: 'a free drink',
    side: 'a free side',
    side_and_drink: 'a free side + drink',
    meal: 'a free meal',
    everything: 'a free meal, side + drink',
  };
  const perk = (loyalty?.current_tier_free_item || loyalty?.free_item) ? perkLabels[loyalty.current_tier_free_item || loyalty.free_item] : null;
  const pct = loyalty?.current_tier_discount ?? loyalty?.discount_percent;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm px-6"
        data-testid="tier-celebration-overlay"
      >
        <motion.div
          initial={{ scale: 0.7, y: 30, opacity: 0 }}
          animate={{ scale: 1, y: 0, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 260, damping: 20 }}
          className="w-full max-w-sm bg-gradient-to-br from-amber-400 via-amber-500 to-primary rounded-[2rem] p-7 text-center shadow-2xl"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.3, 1] }}
            transition={{ delay: 0.15, duration: 0.6 }}
            className="text-7xl mb-3"
            data-testid="tier-celebration-emoji"
          >
            {loyalty?.tier_emoji || '🏆'}
          </motion.div>
          <p className="text-white/85 text-xs font-bold uppercase tracking-widest mb-1">New tier unlocked</p>
          <h2 className="text-3xl font-bold text-white mb-2" data-testid="tier-celebration-name">
            You've reached {loyalty?.tier_name}!
          </h2>
          <div className="bg-white/20 rounded-2xl px-4 py-3 mb-5">
            <p className="text-white text-sm font-semibold flex items-center justify-center gap-1.5">
              <Gift className="h-4 w-4" /> {pct}% off{perk ? ` + ${perk}` : ''}
            </p>
            <p className="text-white/85 text-xs mt-1">applies automatically to your next eligible order</p>
          </div>
          <button
            onClick={onClose}
            className="w-full h-12 bg-white text-amber-700 rounded-xl font-bold text-sm active:scale-95 transition-transform"
            data-testid="tier-celebration-dismiss"
          >
            Let's eat! 🎉
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
